import React from 'react';
import { Gift } from 'lucide-react';
export function BonusSection() {
  const bonuses = [{
    number: '1',
    title: 'Guía Maestra de Planificación Anual',
    description: 'Modelo estructurado para organizar todo el año lectivo de Geografía, con planificación editable y adaptable a tu institución y provincia.'
  }, {
    number: '2',
    title: 'Guía Docente de Primeros Auxilios',
    description: 'Material práctico de apoyo para situaciones escolares frecuentes, pensado para acompañar al docente en contextos reales del aula.'
  }, {
    number: '3',
    title: 'Maletín de Actividades',
    description: 'Banco ampliado de actividades listas para usar, dinámicas, consignas y propuestas aplicables en distintas unidades y cursos.'
  }];
  return <section id="bonus" className="py-8 sm:py-14 bg-white" data-id="element-31">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-32">
        <div className="text-center mb-6 sm:mb-10" data-id="element-33">
          <h2 className="text-xl sm:text-3xl md:text-4xl font-black text-gray-900 mb-2 sm:mb-4" data-id="element-34">
            BONUS exclusivos incluidos con tu compra
          </h2>
          <p className="text-xs sm:text-base text-gray-500 max-w-2xl mx-auto mb-4 sm:mb-6" data-id="element-35">
            Para que puedas organizar mejor tu año, tener respaldo profesional y
            contar con más recursos prácticos, sumamos 3 bonus listos para usar:
          </p>

          <div className="inline-block bg-gradient-to-r from-red-600 to-red-500 text-white font-black text-xs sm:text-base md:text-lg px-4 sm:px-6 py-1.5 sm:py-2 rounded-lg shadow-lg" data-id="element-36">
            🎁 ¡GRATIS POR EL DÍA DE HOY!
          </div>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-37">
          {bonuses.map((bonus, i) => <div key={i} className="bg-gray-50 border border-gray-200 rounded-xl p-4 sm:p-6 flex items-start gap-3 sm:gap-4" data-id="element-38">
              <div className="flex-shrink-0 bg-[#fbbf24]/10 border border-[#fbbf24]/30 rounded-lg w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center" data-id="element-39">
                <Gift className="h-5 w-5 sm:h-6 sm:w-6 text-[#fbbf24]" data-id="element-40" />
              </div>
              <div className="flex-1" data-id="element-41">
                <h3 className="text-sm sm:text-lg font-bold text-gray-900 mb-1" data-id="element-42">
                  BONUS #{bonus.number} — {bonus.title}
                </h3>
                <p className="text-gray-500 text-xs sm:text-sm leading-relaxed" data-id="element-43">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}